import React from 'react';
import styled from '@emotion/styled';

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

const LogoIcon = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #2a2a2a 0%, #4a4a4a 20%, #1a1a1a 40%, #3a3a3a 60%, #252525 80%, #333333 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  transform: translateY(3px);
`;

const WolfHead = styled.div`
  width: 28.8px; /* 24px * 1.2 = 28.8px (20% bigger) */
  height: 28.8px; /* 24px * 1.2 = 28.8px (20% bigger) */
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: brightness(0) invert(1); /* Makes the image white */
  }
`;

const LogoText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const BrandName = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  font-weight: normal;
  color: white;
  letter-spacing: -0.75px;
  line-height: 1;
  
`;

const Tagline = styled.span`
  font-size: 0.7rem;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 400;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  margin-top: 4px;
  font-family: Inter, sans-serif;
`;

function VerisureLogo({ size = 'normal' }) {
  const iconSize = size === 'small' ? '32px' : '40px';
  const textSize = size === 'small' ? '1.25rem' : '1.5rem';
  const taglineSize = size === 'small' ? '0.6rem' : '0.7rem';
  
  return (
    <LogoContainer>
      <LogoIcon style={{ width: iconSize, height: iconSize }}>
        <WolfHead>
          <img src="/wolf-head.png" alt="Wolf Head Logo" />
        </WolfHead>
      </LogoIcon>
      <LogoText>
        <BrandName style={{ fontSize: textSize }}>
          <span style={{ fontWeight: '500', letterSpacing: '0.01px' }}>verisure</span>
        </BrandName>
        <Tagline style={{ fontSize: taglineSize }}>A Wolf Data Solution</Tagline>
      </LogoText>
    </LogoContainer>
  );
}

export default VerisureLogo;
